import { createAction, props } from '@ngrx/store';

/**
 * The change connection network action
 */
export const connectionChange = createAction('[Network] connectionChange', props<{ connectionType: string }>());
